import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getDairyFootprintByYear, getDairyFootprintByYearAdmin } from "services";

import { getActiveToken, getEnvironment, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_DAIRY } from "consts";

export const useGetFootprintingDairyFootprints = (farmId?: string, years: number[] = [], { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  // User context hook returns `null` on admin for whatever reason
  const isLoggedIn = isAdmin ? !!token : !!user && !!token;

  return useQueries({
    queries: years.map((year) => ({
      queryKey: [FOOTPRINTING_DAIRY, farmId, year, isAdmin],
      queryFn: () => (isAdmin ? getDairyFootprintByYearAdmin(farmId ?? "", year) : getDairyFootprintByYear(farmId ?? "", year)),
      enabled:
        enabled &&
        !!carbonProgram?.platformFeatures?.footprinting?.enabled &&
        carbonProgram.platformFeatures.footprinting.dairy === true &&
        !!farmId &&
        isLoggedIn,
      queryClient,
      gcTime: 60000,
    })),
  });
};
